/**
 * Dismiss the first-paint splash defined in index.html.
 *
 * The splash covers the window between the first paint and the app having
 * something real to show. Before it existed, the header and a bare
 * "Loading..." rendered first, and the ResumeX loader only appeared once both
 * the landing chunk and the auth check had resolved.
 *
 * Safe to call more than once, and safe if the element is already gone.
 */
export function hideAppSplash(): void {
  (window as unknown as { __rxHideSplash?: () => void }).__rxHideSplash?.();
}
